import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import MobileBottomNav from "@/components/MobileBottomNav";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Product from "@/pages/Product";
import Search from "@/pages/Search";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import Favorites from "@/pages/Favorites";
import Institutional from "@/pages/Institutional";
import Categories from "@/pages/Categories";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminOrders from "@/pages/admin/Orders";
import AdminCustomers from "@/pages/admin/Customers";
import AdminSettings from "@/pages/admin/Settings";
import AdminLogin from "@/pages/admin/AdminLogin";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer />
      <WhatsAppButton />
      <MobileBottomNav />
      <CartDrawer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/categorias" element={<Shell><Categories /></Shell>} />
            <Route path="/categoria/:name" element={<Shell><Category /></Shell>} />
            <Route path="/produto/:slug" element={<Shell><Product /></Shell>} />
            <Route path="/buscar" element={<Shell><Search /></Shell>} />
            <Route path="/checkout" element={<Shell><Checkout /></Shell>} />
            <Route path="/pedido/:orderId" element={<Shell><OrderSuccess /></Shell>} />
            <Route path="/entrar" element={<Shell><Login /></Shell>} />
            <Route path="/cadastro" element={<Shell><Register /></Shell>} />
            <Route path="/recuperar-senha" element={<Shell><ForgotPassword /></Shell>} />
            <Route path="/redefinir-senha" element={<Shell><ResetPassword /></Shell>} />
            <Route path="/conta" element={<Shell><Account /></Shell>} />
            <Route path="/favoritos" element={<Shell><Favorites /></Shell>} />
            <Route path="/institucional/:page" element={<Shell><Institutional /></Shell>} />
            <Route path="/admin/entrar" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/produtos" element={<AdminProducts />} />
            <Route path="/admin/pedidos" element={<AdminOrders />} />
            <Route path="/admin/clientes" element={<AdminCustomers />} />
            <Route path="/admin/configuracoes" element={<AdminSettings />} />
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
